import { ref, remove, get, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetSaleReturnDataFirebase from "./GetSaleReturnDataFirebase";

const DeleteSaleReturnDataInFirebase = async (state, dispatch, uniqueID, userId) => {

    const USERID = userId ? userId : state?.USERID

    console.log("userid", USERID);
    console.log("uniqueID", uniqueID);

    if (!USERID) return null;

    try {

        // Reference to the specific invoice in Firebase
        const userRef = ref(database, `invoiceGenerator/users/${USERID}/returnInvoice/${uniqueID}`);

        const snapshot = await get(userRef);
        if (!snapshot.exists()) {
            return { success: false, message: "sales return not found." };
        }

        // Instead of deleting, just mark as deleted
        await update(userRef, { isDeleted: true,
            deletedBy: state?.USERID || "guest" });

        // Fetch updated invoice data after deletion
        await GetSaleReturnDataFirebase(state, dispatch);

        return { success: true, message: "SaleReturn deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || "Failed to delete SaleReturn." };
    }
};

export default DeleteSaleReturnDataInFirebase;
